import { render } from "./MyOrder.vue?vue&type=template&id=7a617fd4&scoped=true"
import script from "./MyOrder.vue?vue&type=script&lang=ts"
export * from "./MyOrder.vue?vue&type=script&lang=ts"

import "./MyOrder.vue?vue&type=style&index=0&id=7a617fd4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7a617fd4"

export default script